/**
 * Created by lenovo on 2017/5/10.
 */
import React, {
    Component,
    PropTypes
} from 'react';
import {Link} from 'react-router'
import {language,resultTip} from 'UTIL/common'
import ellaService from 'SERVICES/purifier/ella/ellaService'
import BoxHeader from "CONFIG/component/boxHeader"
import ContentHeader from 'CONFIG/component/contentHeaderLeft'
import {timesTampsToData} from 'CONFIG/function'
export default class SubsystemDetail extends Component{
    constructor(props){
        super(props);
        this.state = {
            detailList : {},
        }
    }
    componentDidMount(){
        var id = this.props.params.id;
        ellaService.subsystemToUpdate(id).then(body=>{
            console.log(body.data)
            const json = body.data.subsystem ;
            this.setState({
                detailList : json
            })
        })
    }
    render(){
        var row = this.state.detailList;
        return <div>
            <ContentHeader nameLg="Subsystem" nameSm="DetailSubsystem"/>
            <section className="content">
                <div className="box box-primary color-palette-box">
                    <BoxHeader title="DetailSubsystem"/>
                    <div className="box-body">
                        <table id="yjcz" className="table table-bordered table-striped dataTable">
                            <tbody>
                            <tr>
                                <td className="fontWeightBig">{language()['SubsystemName']}</td>
                                <td className="fontWeightSmall">{row.name}</td>
                                <td className="fontWeightBig">{language()['SubsystemNumber']}</td>
                                <td>{row.number}</td>
                            </tr>
                            <tr>
                                <td className="fontWeightBig">{language()['AccessPath']}</td>
                                <td className="fontWeightSmall">{row.url}</td>
                            </tr>
                            <tr>
                                <td className="fontWeightBig">{language()['remark']}</td>
                                <td colSpan="3">{row.remark}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="box-footer">
                        <div className="col-xs-1 text-center">
                            <Link to={"/ella/permission/subsystemIndex"} className="btn btn-default">{language()['return']}</Link>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    }
}


// WEBPACK FOOTER //
// ./modules/ella/permission/subsystem/subsystemDetail.js